module.exports = __webpack_public_path__ + "static/media/img_car_1_desktop.ca91a841.png";